export default __webpack_public_path__ + "static/media/upload_exchange.c0c0bd2b.png";